import { getTokenLocal } from "../../utils/localStorage.util";
import ApiRoutes from "../../configs/endpoints.config";
import HttpClient from "../index.api";
const baseURL = process.env.REACT_APP_API_URL;
class Auth extends HttpClient {
  constructor() {
    super(baseURL);
    this._initializeRequestInterceptor();
    this._initializeResponseInterceptor();
  }

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${getTokenLocal()}`;
      return config;
    });
  };

  _initializeResponseInterceptor = () => {
    this.instance.interceptors.response.use(
      (response) => {
        return response;
      },
      (response) => {
        return Promise.resolve(response);
      }
    );
  };

  loginConfig = ApiRoutes.Auth.Login;
  SignUpConfig = ApiRoutes.Auth.SignUp;
  ForgetPasswordConfig = ApiRoutes.Auth.ForgetPassword;
  verifyOtpConfig = ApiRoutes.Auth.VerifyOtp;
  resendOtpConfig = ApiRoutes.Auth.ResendOtp;
  resetPasswordConfig = ApiRoutes.Auth.ResetPassword;

  login = async (reqBody) => {
    return this.instance({
      method: this.loginConfig.Method,
      url: this.loginConfig.Endpoint,
      headers: {},
      data: reqBody,
    });
  };
  signUp = async (reqBody) => {
    return this.instance({
      method: this.SignUpConfig.Method,
      url: this.SignUpConfig.Endpoint,
      headers: {},
      data: reqBody,
    });
  };

  forgotPassword = async (reqBody) => {
    return this.instance({
      method: this.ForgetPasswordConfig.Method,
      url: this.ForgetPasswordConfig.Endpoint,
      headers: {},
      data: reqBody,
    });
  };

  verifyOtp = async (reqBody) => {
    return this.instance({
      method: this.verifyOtpConfig.Method,
      url: this.verifyOtpConfig.Endpoint,
      headers: {},
      data: reqBody,
    });
  };

  resetPassword = async (reqBody) => {
    return this.instance({
      method: this.resetPasswordConfig.Method,
      url: this.resetPasswordConfig.Endpoint,
      headers: {},
      data: reqBody,
    });
  };


  resendOtp = async (reqBody) => {
    return this.instance({
      method: this.resendOtpConfig.Method,
      url: this.resendOtpConfig.Endpoint,
      headers: {},
      data: reqBody,
    });
  };
}

export default Auth;
